export const MY_LEARNING_TABS = ['all', 'videos', 'courses-and-lessons', 'playlists'];
export const MyLearningTabTypeToRequestMapping = {
  all: [],
  'courses-and-lessons': ['TRACK', 'LESSON', 'TEMPLATE', 'EBOOK'],
  videos: ['SHORT_FORM_CONTENT'],
  playlists: ['PLAYLIST', 'LEARNING_PATH']
};